import { BaseEntity } from "./base.model";

export interface CompanyUser extends BaseEntity {
  username: string;
  companyId: string;
  name: string;
  type: CompanyUserType;
  email: string;
  userStatus: CognitoUserStatus;
  enabled: boolean;
  emailVerified: boolean;
  picture?: string;
  password?: string;
  bindDevices?: string[];
  firebaseTokens?: string[];
  hierarchies: string[];
}

export enum CompanyUserType {
  "root" = "root",
  "admin" = "admin",
  "viewer" = "viewer",
}

export enum CognitoUserStatus {
  "UNCONFIRMED" = "UNCONFIRMED",
  "CONFIRMED" = "CONFIRMED",
  "ARCHIVED" = "ARCHIVED",
  "COMPROMISED" = "COMPROMISED",
  "UNKNOWN" = "UNKNOWN",
  "RESET_REQUIRED" = "RESET_REQUIRED",
  "FORCE_CHANGE_PASSWORD" = "FORCE_CHANGE_PASSWORD",
}
